import { render, staticRenderFns } from "./DesignCard.vue?vue&type=template&id=6834af8f&scoped=true"
import script from "./DesignCard.vue?vue&type=script&lang=js"
export * from "./DesignCard.vue?vue&type=script&lang=js"
import style0 from "./DesignCard.vue?vue&type=style&index=0&id=6834af8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834af8f",
  null
  
)

export default component.exports